import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const ResetPasswordSlice = createSlice({
  name: 'ResetPassword',
  initialState,
  reducers: {
    ResetPassword_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    ResetPassword_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    ResetPassword_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_ResetPassword_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {  ResetPassword_request, ResetPassword_success,  ResetPassword_failure, Clear_ResetPassword_Check } = ResetPasswordSlice.actions

export default ResetPasswordSlice.reducer